"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsInView = void 0;
var react_1 = require("react");
var useIsInView = function (options) {
    if (options === void 0) { options = {}; }
    var _a = __read((0, react_1.useState)(window.IntersectionObserver ? false : true), 2), isInView = _a[0], setIsInView = _a[1];
    var observerRef = (0, react_1.useRef)();
    var rootRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        var observer = null;
        if (window.IntersectionObserver && observerRef.current) {
            observer = new IntersectionObserver(function (entries, obs) {
                if (entries[0].isIntersecting) {
                    setIsInView(true);
                    if (options.trueOnce)
                        obs.unobserve(observerRef.current);
                }
                else {
                    setIsInView(false);
                    if (options.falseOnce)
                        obs.unobserve(observerRef.current);
                }
            }, {
                root: rootRef.current,
                rootMargin: options.rootMargin || '0px',
                threshold: options.threshold || 0
            });
            observer.observe(observerRef.current);
        }
        return function () { return observer === null || observer === void 0 ? void 0 : observer.disconnect(); };
    }, []);
    return { isInView: isInView, observerRef: observerRef, rootRef: rootRef };
};
exports.useIsInView = useIsInView;
//# sourceMappingURL=index.js.map